import { Box, Paper, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import BillingPatients from "./BillingPatients";
import BilledPatients from "./BilledPatients";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{}}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function BillingTabComponent() {
  const [value, setValue] = useState(0);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <Paper sx={{ width: "100%", height: "calc(100dvh - 101px)" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          variant="fullWidth"
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Patients" {...a11yProps(0)} />
          <Tab label="Billed patients" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <BillingPatients />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
          <BilledPatients />
      </CustomTabPanel>
    </Paper>
  );
}

export default BillingTabComponent;
